import FavoriteButton from './FavoritesButton'

const AddRetailerToFavorites = ({ retailer, customerId }) => {
  return (
    <div>
      <FavoriteButton
        retailer={retailer}
        isFavorite={retailer.isFavorite}
        customerId={customerId}
      />
    </div>
  )
}
export default AddRetailerToFavorites
